import { cronosClient } from "@/config/client"
import type { GetCourseResponse } from "./get"

export function getByToken(token: string) {
  return cronosClient
    .setDefaultHeader("Authorization", `Bearer ${token}`)
    .get<GetCourseResponse>("/v1/courses")
}
